import { Button } from "@mui/joy";
import { debounce } from "lodash";
import { AddIcon } from "static/image/common/IconAssets";
import useIsRecordSeparatedPage from "hooks/useIsRecordSeparatedPage";
import useIsInappWebview from "hooks/useIsInappWebview";
import { useNavigate } from "react-router-dom";
import { generateThoughtRecordKey } from "logic/logics";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import useOpenNewThoughtRecord from "hooks/useOpenNewThoughtRecord";
import { SentimentType } from "api/thoughtRecordApi";

export default function AddNewThoughtRecordButton({
  disabled,
  sentiment = "negative",
}: {
  disabled: boolean;
  sentiment?: SentimentType;
}) {
  const isRecordSeparatedPage = useIsRecordSeparatedPage();
  const isTaskContainerSmall = useIsInappWebview();
  const navigate = useNavigate();
  const userState = useRecoilValue(userAtom);
  const openNewThoughtRecord = useOpenNewThoughtRecord(sentiment);

  const debouncedOnClick = debounce(() => {
    if (isRecordSeparatedPage) {
      const newThoughtRecordKey = generateThoughtRecordKey(userState?.userId!!);
      navigate(`/thought-record-detail?trk=${newThoughtRecordKey}&sentiment=${sentiment}`);
    } else {
      openNewThoughtRecord();
    }
  }, 100);

  return (
    <Button
      fullWidth
      onClick={debouncedOnClick}
      size={isTaskContainerSmall && !isRecordSeparatedPage ? "sm" : "lg"}
      variant="Soft"
      sx={{
        minWidth: 0,
        paddingInline: 0,
        ...(isTaskContainerSmall &&
          !isRecordSeparatedPage && { width: "64px", "--Button-gap": 0 }),
        ...((!isTaskContainerSmall || isRecordSeparatedPage) && {
          "--Button-gap": "4px",
        }),
      }}
      disabled={disabled}
      startDecorator={<AddIcon size={16} />}
    >
      {(!isTaskContainerSmall || isRecordSeparatedPage) && "기록하기"}
    </Button>
  );
}
